import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface DialogState {
  interviewDocumentation: {
    isOpen: boolean
    applicantId: number | null
    lastFocusedField: string | null
  }
  // Add other dialogs here as needed
}

const initialState: DialogState = {
  interviewDocumentation: {
    isOpen: false,
    applicantId: null,
    lastFocusedField: null
  }
}

const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    openInterviewDocumentationDialog: (
      state,
      action: PayloadAction<{ applicantId: number }>
    ) => {
      state.interviewDocumentation.isOpen = true
      state.interviewDocumentation.applicantId = action.payload.applicantId
    },
    closeInterviewDocumentationDialog: (state) => {
      state.interviewDocumentation.isOpen = false
      state.interviewDocumentation.applicantId = null
      state.interviewDocumentation.lastFocusedField = null
    },
    setInterviewDocumentationFocus: (
      state,
      action: PayloadAction<{ fieldId: string | null }>
    ) => {
      state.interviewDocumentation.lastFocusedField = action.payload.fieldId
    }
  }
})

export const {
  openInterviewDocumentationDialog,
  closeInterviewDocumentationDialog,
  setInterviewDocumentationFocus
} = dialogSlice.actions

export const selectInterviewDocumentationDialog = (state: {
  dialog: DialogState
}) => state.dialog.interviewDocumentation

export default dialogSlice.reducer
